// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-link-table{width:100%}.h-link-table td,.h-link-table th{vertical-align:middle}.h-link-table td{padding:10px}.h-link-table td:first-child{border-right-color:transparent}.h-link-table td:last-child{border-left-color:transparent}.h-link-table__text{width:100%}.h-link-table__link{white-space:nowrap}.h-link-table__link__btn{min-width:0;padding:0 17px;margin:0}", ""]);
// Exports
module.exports = exports;
